import { hasDiagramDarkMode } from '@y42/gojs';
import { Binding, GraphObject, Part } from 'gojs';
import {
  isOrchestrationDiagramEditable,
  OrchestrationDiagramMode,
  OrchestrationDiagramModelProperties,
} from '../../../../models/orchestration-diagram.model';
import { orchestrationDiagramConfig } from '../../../config/orchestration-diagram.config';
import { OrchestrationLinkContextMenu } from '../../shared/parts/link-context-menu';

export const linkStrokeBinding = () =>
  new Binding('stroke', '', (object: GraphObject, part: Part) => {
    const hasDarkMode = hasDiagramDarkMode(part.diagram);
    if (object.part?.isHighlighted) {
      return hasDarkMode
        ? orchestrationDiagramConfig.link.dark.highlighted
        : orchestrationDiagramConfig.link.light.highlighted;
    }
    return hasDarkMode ? orchestrationDiagramConfig.link.dark.default : orchestrationDiagramConfig.link.light.default;
  }).ofObject();

export const linkDeleteableBinding = () =>
  new Binding('deletable', OrchestrationDiagramModelProperties.DiagramMode, (mode: OrchestrationDiagramMode) =>
    isOrchestrationDiagramEditable(mode),
  ).ofModel();

export const linkContextMenuBinding = () =>
  new Binding('contextMenu', OrchestrationDiagramModelProperties.DiagramMode, (mode: OrchestrationDiagramMode) =>
    isOrchestrationDiagramEditable(mode) ? OrchestrationLinkContextMenu() : null,
  ).ofModel();
